// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import {
  iBlockSchema,
  blockBaseSettingsSchema,
  iBlockFieldSchema
} from './baseBlock.zod'

export const accountFieldSchema = iBlockFieldSchema

export const accountBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.ACCOUNT),
  required: z.literal(false),
  settings: blockBaseSettingsSchema.and(
    z.object({
      purposeLabels: z.array(z.string()),
      fields: z.object({
        email: accountFieldSchema,
        telephone: accountFieldSchema,
        companyName: accountFieldSchema,
        registryCourt: accountFieldSchema,
        registerNumber: accountFieldSchema
      })
    })
  )
})

export const accountBlockValueSchema = z.object({
  email: z.string().optional(),
  telephone: z.string().optional(),
  companyName: z.string().optional(),
  registryCourt: z.string().optional(),
  registerNumber: z.string().optional()
})
